import {addScript} from "../../state";

const FormatCustomScriptsData = (scriptData) => {

    scriptData.forEach(scriptEntry => {
        addScript(scriptEntry);
    })
  
};

export default FormatCustomScriptsData;
